import React, { useState, useRef } from "react";
import { Validation } from 'regexes';
import { Form, List, Popup } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { appStore } from "../stores/AppStore";

export const FormPassword = () => {
    const inputClearTextPassword = useRef(null);
    const inputClearTextPassword2 = useRef(null);
    const [t] = useTranslation();
    const [showPassword, setShowPassword] = useState(false);
    const [passwordIcon, setPasswordIcon] = useState("");
    const [passwordReqMinimumLength, setpasswordReqMinimumLength] = useState(false);
    const [passwordReqOneLowerCase, setPasswordReqOneLowerCase] = useState(false);
    const [passwordReqOneNumberOrSpecialChar, setPasswordReqOneNumberOrSpecialChar] = useState(false);
    const [passwordFieldHasFocus, setPasswordFieldHasFocus] = useState(false);
    const [notCompleteHighlight, setNotCompleteHighlight] = useState(null)

    const onFormChange = () => {
        const pwd = inputClearTextPassword.current.value.trim();
        const pwd2 = inputClearTextPassword2.current.value.trim();
        const isPasswordGood = Validation.Password.test(pwd) && pwd === pwd2;
        setpasswordReqMinimumLength(pwd.length > 7);
        setPasswordReqOneLowerCase(/(.*[a-z].*)/.test(pwd));
        setPasswordReqOneNumberOrSpecialChar(/(.*\d)|(.[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/.test(pwd));
        setNotCompleteHighlight(!isPasswordGood && pwd.length > 0 && !passwordFieldHasFocus ? { borderColor: "#e0b4b4", color: "#9f3a38" } : null)
        if (isPasswordGood) {
            appStore.password = pwd;
            setPasswordIcon("icon-chat-1");
        } else {
            appStore.password = "";
            setPasswordIcon("");
        }
    }

    return (
        <Form.Group widths="equal" style={{ position: "relative" }} onChange={onFormChange}>
            <Form.Field>
                <div className="ui left icon input">
                    <i
                        aria-hidden="true"
                        className={
                            !showPassword ? "eye link icon" : "eye slash link icon"
                        }
                        onClick={e => setShowPassword(!showPassword)}
                    />
                    <Popup
                        trigger={
                            <input
                                ref={inputClearTextPassword}
                                type={showPassword ? "text" : "password"}
                                name="password"
                                placeholder={t("password_placeholder")}
                                onFocus={() => setPasswordFieldHasFocus(true)}
                                onBlur={() => setPasswordFieldHasFocus(false)}
                                style={notCompleteHighlight}
                            />
                        }
                        on="focus"
                    >
                        <Popup.Header>
                            <span className="popup-header">
                                {t("password_requirements")}
                            </span>
                        </Popup.Header>
                        <Popup.Content className="password-check-popup-content">
                            <List>
                                <List.Item>
                                    <List.Icon>
                                        {passwordReqMinimumLength ? (
                                            <i
                                                aria-hidden="true"
                                                className="ui icon check circle password-icon-success-color"
                                            />
                                        ) : (
                                            <i
                                                aria-hidden="true"
                                                className="ui icon circle outline red"
                                            />
                                        )}
                                    </List.Icon>
                                    <List.Content>
                                        {t("password_req_min_length")}
                                    </List.Content>
                                </List.Item>
                                <List.Item>
                                    <List.Icon>
                                        {passwordReqOneLowerCase ? (
                                            <i
                                                aria-hidden="true"
                                                className="ui icon check circle password-icon-success-color"
                                            />
                                        ) : (
                                            <i
                                                aria-hidden="true"
                                                className="ui icon circle outline red"
                                            />
                                        )}
                                    </List.Icon>
                                    <List.Content>
                                        {t("password_req_lowercase")}
                                    </List.Content>
                                </List.Item>
                                <List.Item>
                                    <List.Icon>
                                        {passwordReqOneNumberOrSpecialChar ? (
                                            <i
                                                aria-hidden="true"
                                                className="ui icon check circle password-icon-success-color"
                                            />
                                        ) : (
                                            <i
                                                aria-hidden="true"
                                                className="ui icon circle outline red"
                                            />
                                        )}
                                    </List.Icon>
                                    <List.Content>
                                        {t("password_req_number_or_special")}
                                    </List.Content>
                                </List.Item>
                            </List>
                        </Popup.Content>
                    </Popup>
                </div>

                <div
                    className={appStore.password ? "password-icon-success-color" : ""}
                    style={{ position: "absolute", right: -36, top: 7 }}
                >
                    <i
                        className={`ui icon glg-streamline-icon ${passwordIcon} big`}
                        style={{ fontSize: 24 }}
                    />
                </div>
            </Form.Field>
            <Form.Field style={{ position: "relative" }}>
                <input
                    ref={inputClearTextPassword2}
                    type={showPassword ? "text" : "password"}
                    name="password2"
                    placeholder={t("password_placeholder2")}
                    style={notCompleteHighlight}
                />
            </Form.Field>
        </Form.Group>
    )
}